<template>
  <v-card>
        <v-container fluid grid-list-md>

    <v-dialog v-model="fiUsersDialog">
      <v-card>
        <v-flex xs12>
        <v-card-title>
          <v-flex xs1>
          <v-img v-if="selectedFI != null" :src="selectedFI.logo" :width=40 :height=40 />
        </v-flex>
          <v-flex xs11>
          <span class="headline">{{getFIUsersTitle}}</span>
        </v-flex>
        </v-card-title>
        </v-flex>
        <v-card-text>
          <v-data-table
            v-model="selected"
            :headers="fiUsersHeaders"
            :items="fiUsers"
            item-key="userInstitutionId"
            class="elevation-5"
            show-select
            :rows-per-page="rowsPerPage"
            :items-per-page-options="rppItems"
          >
            <template slot="item" slot-scope="props">
              <tr>
                <td>
                  <v-simple-checkbox
                    v-model="props.selected"
                    primary
                    hide-details
                  ></v-simple-checkbox>
                </td>
                <td class="text-xs">{{ props.item.userId }}</td>
                <td class="text-xs">{{ props.item.userName }}</td>
                <td class="text-xs">{{ props.item.firstName }}</td>
                <td class="text-xs">{{ props.item.lastName }}</td>
                <td class="text-xs">{{ props.item.userInstitutionId }}</td>
                <td class="text-xs">{{ props.item.statusCode }}</td>
                <td class="text-xs">{{ props.item.aggregatorCreatedDate }}</td>
                <td class="text-xs">{{ props.item.aggregatorLastRefreshAttempt }}</td>
                <td class="text-xs">{{ props.item.aggregatorLastRefreshed }}</td>
                <td class="text-xs">{{ props.item.aggregatorNextRefreshAttempt }}</td>
                <td class="text-xs">{{ props.item.updatedDate }}</td>
                <td class="justify-center layout px-0">
                  <v-icon small @click="refreshSelectedUserFIs(props.item)">autorenew</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="selected == null || selected.length < 1" color="blue darken-1" text @click="refreshSelectedUserFIs">Refresh</v-btn>
          <v-btn color="blue darken-1" text @click="closeFIUsers">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table
      :headers="headers"
      :items="institutionList"
      :loading="loadingFIs"
      item-key="aggregatorBankID"
      class="elevation-1"
      :search="search"
      :rows-per-page="rowsPerPage"
      :items-per-page-options="rppItems"
    >
      <template slot="item" slot-scope="props">
        <tr>
          <td>
            <v-img :src="props.item.logo" :width=40 :height=40 />
          </td>
          <td class="text-xs-center">{{ props.item.aggregatorBankID }}</td>
          <td class="text-xs">{{ props.item.name }}</td>
          <td class="text-xs">{{ props.item.aggregator }}</td>
          <td class="text-xs">{{ props.item.providerId }}</td>
          <td class="text-xs">{{ props.item.active }}</td>
          <td class="text-xs">{{ props.item.enabled }}</td>
          <td class="text-xs">{{ props.item.primaryAccountEnabled }}</td>
          <td class="justify-center layout px-0">
            <v-icon small class="mr-2" @click="openFIUsersDialog(props.item)">visibility</v-icon>
            <v-icon small @click="refreshFI(props.item.aggregator, props.item.id)">autorenew</v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
    </v-container>
  </v-card>
</template>

<script>
import moment from 'moment'
let rh = require('@/components/APIs/RequestHandler')

export default {
  // props: ['auth'],

  data: () => ({
    direction: 'top',
    fab: false,
    fling: true,
    tabs: null,
    transition: 'slide-y-reverse-transition',
    pagination: {
      sortBy: 'statusCode'
    },
    model: null,
    loadingFIs: false,
    search: '',
    rppItems: [
      10,
      50,
      100,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    rowsPerPage: 25,
    selected: [],
    fiUsersDialog: false,
    fiUsers: [],
    selectedFI: null,
    headers: [
      { text: '', value: '', sortable: false },
      { text: 'Quber ID', align: 'left', value: 'aggregatorBankID' },
      { text: 'Name', value: 'name' },
      { text: 'Aggregator', value: 'aggregator' },
      { text: 'Aggregator Id', value: 'providerId' },
      { text: 'Active', value: 'active' },
      { text: 'Enabled', value: 'enabled' },
      { text: 'Can Be Primary', value: 'primaryAccountEnabled' },
      { text: '', value: '' }
    ],
    institutionList: [],
    fiUsersHeaders: [
      { text: 'User ID', align: 'left', value: 'userId' },
      { text: 'Username', value: 'userName' },
      { text: 'First Name', value: 'firstName' },
      { text: 'Last Name', value: 'lastName' },
      { text: 'Institution Id', value: 'userInstitutionId' },
      { text: 'Status', value: 'statusCode' },
      { text: 'Created', value: 'aggregatorCreatedDate' },
      { text: 'Last Refresh Attempt', value: 'aggregatorLastRefreshAttempt' },
      { text: 'Last Refreshed', value: 'aggregatorLastRefreshed' },
      { text: 'Next Refresh Attempt', value: 'aggregatorNextRefreshAttempt' },
      { text: 'Last Quber Updated', value: 'updatedDate' },
      { text: 'Refresh', value: '' }
    ]
  }),

  components: {},

  computed: {
    getFIUsersTitle () {
      if (this.selectedFI !== undefined && this.selectedFI !== null) {
        return this.selectedFI.name + ' (' + this.selectedFI.aggregator + ')'
      } else {
        return 'Fi Users'
      }
    }
  },

  watch: {
    fiUsersDialog (val) {
      val || this.closeFIUsers()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    async initialize () {
      this.loadingFIs = true
      var endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_FAS
      }/available-institutions`
      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })

      this.institutionList = getResponse.data
      this.loadingFIs = false
    },

    async openFIUsersDialog (fi) {
      this.loadingFIUsers = true
      this.selectedFI = fi
      var endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_FAS
      }/aggregators/${fi.aggregator}/institutions/${fi.providerId}/users`
      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })

      this.fiUsers = getResponse.data
      this.loadingFIUsers = false
      this.fiUsersDialog = true
    },

    async refreshFI (aggregator, id) {
      var endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_FAS
      }/aggregators/${aggregator}/institutions/${id}/refresh`
      var postResponse = await rh.default.post(endpoint, null, true).catch(e => {
        this.errors.push(e)
      })
    },

    refreshSelectedUserFIs (clickedUserFI) {
      if (clickedUserFI) {
        this.selected = [clickedUserFI]
      }
      if (!this.selected || this.selected.length < 1) {
        return
      }
      if (!confirm('Would you like to send a request to refresh the ' + this.selected.length + ' selected user account(s)?')) {
        return
      }
      var endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_FAS
      }/aggregators/institutions/refresh`
      var postResponse = rh.default.post(endpoint, this.selected, true).catch(e => {
        this.errors.push(e)
      })
      this.closeFIUsers()
    },

    closeFIUsers () {
      this.fiUsersDialog = false
      this.selected = []
    }
  }
}
</script>
